import { useEffect, useState, type ReactNode } from 'react'
import { ApiError } from '@/shared/lib/http'

const PENDING_DELAY_MS = 1000

function useDelayedPending(isPending: boolean): boolean {
  const [passed, setPassed] = useState(false)

  useEffect(() => {
    if (!isPending) {
      setPassed(false)
      return
    }
    const timer = window.setTimeout(() => setPassed(true), PENDING_DELAY_MS)
    return () => window.clearTimeout(timer)
  }, [isPending])

  return isPending && passed
}

export function QueryState(props: {
  isPending: boolean
  error: unknown
  isEmpty?: boolean
  emptyMessage?: string
  empty?: ReactNode
  pending?: ReactNode
  children: ReactNode
}) {
  const showPending = useDelayedPending(props.isPending)

  if (props.isPending) {
    // 자리를 지키는 뼈대는 **처음부터** 그린다 — 이것은 «작업 중» 알림이 아니라 레이아웃이다.
    // 1초를 기다리게 하면 그 사이 화면이 비어 그게 곧 깜빡임이 된다.
    if (props.pending !== undefined) return <>{props.pending}</>
    return showPending ? <p className="text-label text-black-100">불러오는 중…</p> : null
  }

  if (props.error) {
    const msg =
      props.error instanceof ApiError
        ? (props.error.detail[0] ?? props.error.code)
        : '알 수 없는 오류가 발생했습니다.'
    return (
      <div className="rounded-lg bg-[#fdecec] px-4 py-3.5 text-label text-[#7a1f1f]">
        <b>불러오지 못했습니다.</b> {msg}
      </div>
    )
  }

  if (props.isEmpty) {
    if (props.empty !== undefined) return <>{props.empty}</>
    return <p className="text-label text-black-100">{props.emptyMessage ?? '표시할 항목이 없습니다.'}</p>
  }

  return <>{props.children}</>
}
